/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Fix: ILS free-shipping message double-counts the currency rate.
// theme.js does cartFreeLimitShipping = 100 * data-limit * Shopify.currency.rate.
// For ILS, data-limit already holds the shekel value (499), so the extra
// rate multiplication inflates the threshold. Strip the rate for ILS only.
(function () {
  function isILS() {
    return !!(window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'ILS');
  }
  function patch() {
    var CartEl = window.customElements && customElements.get('cart-element');
    if (!CartEl || CartEl.__ilsShippingPatched) return !!CartEl;
    var orig = CartEl.prototype.updateProgress;
    if (typeof orig !== 'function') return false;
    CartEl.prototype.updateProgress = function () {
      try {
        if (isILS() && this.cartMessage && this.cartMessage.length > 0) {
          this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute('data-limit'));
        }
      } catch (e) {}
      return orig.apply(this, arguments);
    };
    CartEl.__ilsShippingPatched = true;
    document.querySelectorAll('cart-element').forEach(function (el) {
      if (typeof el.updateProgress === 'function' && el.cartMessage && el.cartMessage.length) {
        try { el.updateProgress(); } catch (e) {}
      }
    });
    return true;
  }
  if (!patch()) {
    var n = 0, iv = setInterval(function () { if (patch() || ++n > 60) clearInterval(iv); }, 100);
  }
  document.addEventListener('theme:cart:loaded', patch);
})();






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
